import { CountryCode } from '@src/common/auth';
import { buildCardPaymentCore } from '@src/domains/payments/core/buildCardPaymentCore';
import { normalizeHolderIdentity } from '@src/domains/payments/core/normalizeHolderIdentity';
import { normalizeZipCode } from '@src/domains/payments/core/normalizeZipCode';
import type { PaymentCardParams } from '@src/domains/payments/types/payment';

export type FormCardInput = {
  holder: string;
  holderIdentity?: string;
  cardNumber: string;
  securityCode: string;
  validity: string;
  installments: number;
  billingAddress?: {
    zipCode?: string;
    state?: string | null;
    city?: string | null;
    district?: string | null;
    street?: string | null;
    number?: string | null;
    complement?: string | null;
  };
};

export const buildPaymentCardParamsFromForm = (
  input: FormCardInput,
  isForeign: boolean,
  buyerCountryCode: CountryCode = CountryCode.BRAZIL,
): PaymentCardParams => {
  const billingAddress = input.billingAddress
    ? {
        ...input.billingAddress,
        zipCode: normalizeZipCode(input.billingAddress.zipCode),
        ...(!isForeign ? { countryCode: buyerCountryCode } : {}),
      }
    : undefined;

  return {
    ...buildCardPaymentCore(input),
    holderIdentity: normalizeHolderIdentity(input.holderIdentity, isForeign),
    billingAddress,
  } as PaymentCardParams;
};
